import "./AccessDenied.css";
import { FaLock, FaHome } from "react-icons/fa";
import { useAuth0 } from "@auth0/auth0-react";

/**
 * Shown on screens that require Auth0 login (e.g. Explore).
 */
export default function LoginRequired({ message }) {
  const { loginWithRedirect } = useAuth0();

  return (
    <div className="access-denied-page">
      <div className="bg-shape bg1"></div>
      <div className="bg-shape bg2"></div>
      <div className="bg-shape bg3"></div>

      <div className="access-card">
        <div className="shield-wrapper">
          <div className="shield">
            <div className="ring"></div>
            <div className="lock-circle">
              <FaLock />
            </div>
          </div>
        </div>

        <h1 style={{ color: "#667085", fontWeight: "700", marginBottom: "18px" }}>
          Sign in required
        </h1>

        <p style={{ color: "#667085", lineHeight: "1.8", marginBottom: "35px" }}>
          {message ||
            "Please sign in to access this page. After logging in, you will return here automatically."}
        </p>

        <div className="button-group">
          <button
            className="btn custom-btn home-btn"
            onClick={() =>
              loginWithRedirect({
                appState: { returnTo: window.location.pathname },
              })
            }
          >
            Sign in
          </button>

          <button
            className="btn btn-light custom-btn"
            onClick={() => (window.location.href = "/")}
          >
            <FaHome />
            Home
          </button>
        </div>
      </div>
    </div>
  );
}
